(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */

    let initializeBlock = function( $block ) {
        // console.log('initializeBlock', 'slider-home');

        let slider   = $block.find('.slider-home');
        let slide    = $block.find('.slide-home');
        let controls = $block.find('.slider-controls');

        let sliderSettings = {
            slide        : '.slide-home',
            rows         : 0,               // fix bug to make slide param works (https://stackoverflow.com/questions/30036742/jquery-slick-carousel-slide-setting)
            dots         : true,
            arrows       : false,
            appendDots   : $(controls),
            speed        : 1000,
            cssEase      : 'linear',
            infinite     : true,
            fade         : true,
            draggable    : false,
            autoplay     : !window.acf,     // no autoplay in admin
            autoplaySpeed: 13000,
        };

        // init -> set active image
        $(slider).on('init', function (event, slick) {
            let currentSlide = 0;
            $('.slide-home[data-slick-index='+currentSlide+']').addClass('is-active');
        });

        if ($(slide).length  > 1) {
            $(slider).slick(sliderSettings);
        }

        // Zoom efx on current slide
        $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.slide-home[data-slick-index='+currentSlide+']').removeClass('is-active');
            $('.slide-home[data-slick-index='+nextSlide+']').addClass('is-active');
        });
    }


    //        Init blocks in front and admin editor
    // ==============================================

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.block-slider-home').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=slider-home', initializeBlock );
    }

})(jQuery);